<template>
    <div @click="checkErrors()">
        <h4><span :class="{'check' : rowsValidated[0] === 'validated', 'x' : rowsValidated[0] === 'error'}"></span>Persoonlijk</h4>
        <div class="group">
            <div class="row" id="Geslacht">
                <div :class="{'element': true, 'error': errors.has('Geslacht')}">
                    <input type="radio" v-model="gender" name="Geslacht" id="vrouw" @click="setGender('d')" value="vrouw" :data-vv-scope="scope" v-validate="'required'"><label for="vrouw">Vrouw</label>
                    <input type="radio" v-model="gender" name="Geslacht" id="man"  @click="setGender('h')" value="man"><label for="man">Man</label>
                    <input type="radio" v-model="gender" name="Geslacht" id="non-binair"  @click="setGender('n')" value="non-binair"><label for="non-binair">Non binair</label>
                    <span v-show="errors.has('personalia.Geslacht')" class="error">{{ errors.first('personalia.Geslacht') }}</span>
                </div>
            </div>
            <div class="row">
                <text-input label="Voornaam" required="required" restrictions="start-with-capital" :scope="scope" class="col"></text-input>
                <text-input label="Tussenvoegsel" :scope="scope" class="col"></text-input>
                <text-input label="Achternaam" required="required" restrictions="start-with-capital" :scope="scope" class="col"></text-input>
            </div>
            <div class="row">
                <text-input label="Geboortedatum (dd-mm-yyyy)" required="required" restrictions="birthdate" :scope="scope" class="col" ></text-input>
                <select-input label="Geboorteland" required="required" :scope="scope" :list="countries" class="col"></select-input>
            </div>
        </div>
        <h4><span :class="{'check' : rowsValidated[1] === 'validated', 'x' : rowsValidated[1] === 'error'}"></span>Adres</h4>
        <div class="group">
            <div class="row">
                <text-input label="Straatnaam" required="required" restrictions="start-with-capital" :scope="scope" class="col"></text-input>
                <text-input label="Huisnummer" required="required" :scope="scope" class="col"></text-input>
            </div>
            <div class="row">
                <text-input label="Postcode" required="required|min:6|max:7" restrictions="zipcode" :scope="scope" class="col"></text-input>
                <text-input label="Woonplaats" required="required" restrictions="start-with-capital" :scope="scope" class="col"></text-input>
                <select-input label="Land" required="required" :scope="scope" :list="countries" class="col"></select-input>
            </div>
        </div>
        <h4><span :class="{'check' : rowsValidated[2] === 'validated', 'x' : rowsValidated[2] === 'error'}"></span>Contact</h4>
        <div class="group">
            <div class="row">
                <text-input label="Mobiel nummer" required="required|phonenumber" :scope="scope" restrictions="numeric" class="col"></text-input>
                <text-input label="Telefoon thuis" required="phonenumber" restrictions="numeric" :scope="scope" class="col"></text-input>
                <text-input label="Telefoon werk" required="phonenumber" restrictions="numeric" :scope="scope" class="col"></text-input>
            </div>
            <div class="row">
                <text-input label="E-mailadres" required="required|email" :scope="scope" class="col" thisRef="email"></text-input>
                <text-input label="E-mailadres verificatie" required="required|confirmEmail" :scope="scope" class="col"></text-input>
            </div>
        </div>
        <!--<h4><span></span>Social</h4>-->
        <!--<div class="group">-->
            <!--<div class="row">-->
                <!--<text-input label="Instagram" :scope="scope" class="col"></text-input>-->
                <!--<text-input label="Youtube" :scope="scope" class="col"></text-input>-->
            <!--</div>-->
        <!--</div>-->
        <h4><span></span>Rijbewijs</h4>
        <div class="group">
            <div class="row">
                <input type="checkbox" name="ind_rijbewijs_motor" id="ind_rijbewijs_motor" class="rijbewijs" value="1"><label for="ind_rijbewijs_motor">Rijbewijs A (Motor)</label>
                <input type="checkbox" name="ind_rijbewijs_auto" id="ind_rijbewijs_auto" class="rijbewijs" value="1"><label for="ind_rijbewijs_auto">Rijbewijs B (Auto)</label>
                <input type="checkbox" name="ind_rijbewijs_vrachtwagen" id="ind_rijbewijs_vrachtwagen" class="rijbewijs" value="1"><label for="ind_rijbewijs_vrachtwagen">Rijbewijs C (Vrachtwagen)</label>
            </div>
        </div>
        <span class="form-error" :class="{'is-visible': errors.has('event_date')}">{{ errors.first('event_date') }}</span>
    </div>
</template>
<script type='text/babel'>
    import TextInput from './elements/Input.vue'
    import DatePicker from './elements/DatePicker.vue'
    import SelectInput from './elements/SelectInput.vue'
    import countries from '../countries'
    import errorCheck from '../errorCheck'
    import {Validator} from 'vee-validate';

    export default {
        inject: ['$validator'],
        props: ['isValidated', 'scope'],
        mixins: [countries, errorCheck],
        components: {
            TextInput,
            SelectInput,
            DatePicker
        },
        data: () => ({
            rowsRequired: {
                0: ['Naam', 'Achternaam', 'GeboorteDatum'],
                1: ['Straatnaam', 'Huisnummer', 'Postcode', 'Woonplaats', 'Land'],
                2: ['Mobiel nummer', 'E-mailadres', 'E-mailadres verificatie']
            },
            gender: ''
        }),
        mounted() {
            Validator.extend('confirmEmail', {
                getMessage: field => 'E-mailadressen komen niet overeen',
                validate: value => value === document.getElementById('E-mailadres').value
            });
            Validator.extend('phonenumber', {
                getMessage: field => 'Geen geldig telefoonnummer',
                validate(value){
                    let n = ~~Number(value);
                    return value.length > 9 && value.length < 16; // leading 0 for phonenumbers
                }
            });
            this.$validator.localize('nl');
        },
        computed: {},
        watch: {
            isValidated() {
                setTimeout(function () {
                    this.checkErrors()
                }.bind(this), 300)
            }
        },
        methods: {
            setGender(g) {
                this.$store.dispatch('setGender', g)
            },
            cleanPhoneInput(){
                value = value.replace('-', '');
            }
        },
    };
</script>
